import { render, staticRenderFns } from "./QuizEditor.vue?vue&type=template&id=5220e3f4&scoped=true"
import script from "./QuizEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuizEditor.vue?vue&type=style&index=0&id=5220e3f4&prod&scoped=true&lang=css"
import style1 from "./QuizEditor.vue?vue&type=style&index=1&id=5220e3f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5220e3f4",
  null
  
)

export default component.exports